import gql from 'graphql-tag';

export const VACATION_MONEY_REPORT = gql`
  query vacationMoneyReport($unitId: ID!, $year: Int!) {
    vacationMoneyReport(unitId: $unitId, year: $year) {
      workRelation {
        id
        employmentPercentage
        employmentType
        occupation {
          id
          name
        }
        employee {
          id
          firstName
          lastName
        }
        subUnit {
          id
          name
        }
      }
      vacationMoneyBaseAmount
      vacationMoneyPercentage
      vacationMoneyAmount
      paidReportYearAmount
      shouldExcludeAmounts
      leftToPayReportYearRealAmount
      leftToPayReportYearAmount
      municipality {
        id
        name
      }
      municipalityTaxPercentage
      employersTaxRealAmount
      employersTaxAmount
      leftVacationMoneyBaseRealAmount
      leftVacationMoneyBaseAmount
      paidNextYearPaychecks {
        id
        number
      }
      paidNextYearAmount
      leftToPayNextYearRealAmount
      leftToPayNextYearAmount
    }
  }
`;

export const VACATION_MONEY_REPORT_SETTINGS = gql`
  query settingsVacationMoneyReport($unitId: ID!, $year: Int!) {
    settingsVacationMoneyReport(unitId: $unitId, year: $year) {
      excludePositiveAmountsTo
      excludeNegativeAmountsTo
    }
  }
`;
